import { useMutation } from "@tanstack/react-query";
import ApiClient from "../../lib/api-client";
import { queryUtils } from "../../lib/query-client";
import { useCustomNavigate } from "../use-custom-navigate";

export default function useSignOut() {
  const navigate = useCustomNavigate();

  const { mutate: signOut, isPending: isSigningOut } = useMutation({
    mutationFn: () => ApiClient.signOut(undefined, {}),
    onSettled: () => {
      queryUtils.auth.invalidateAll();
    },
    onSuccess: () => {
      navigate("/login");
    },
  });

  return { signOut, isSigningOut };
}
